export default function checkFacilityId(facilityParam: string | null): string | null {
	if (!facilityParam) {
		console.warn('checkFacilitySupport(): no facilityParam was provided.');
		return null;
	}

	if (!/^(AZ_|LV_)\d{1,6}$/.test(facilityParam)) {
		console.warn('checkFacilitySupport(): invalid facilityParam was provided.');
		return null;
	}

	return facilityParam.slice(3);
}
